import { ISkillBlockResource } from "@sol/sdk/skill-blocks";
import { ISkillDomainResource } from "@sol/sdk/skill-domains";

import { IUserResource } from "../../users";
import {
    createApiQueryHook,
    IApiQueryFunction,
    IOrderable,
    IPaginateable,
    mapOrder,
    mapPagination,
} from "../../utils/api";
import { mapRelationalFilter, RelationalFilter } from "../../utils/filters";
import { serialize } from "../../utils/url";
import { IBadgeEarnedList } from "../types";

export interface IBadgeEarnedListQueryParameters extends IPaginateable, IOrderable<"earnedAt"> {
    filters?: {
        learner?: RelationalFilter<IUserResource>;
        skillGroup?: RelationalFilter<ISkillDomainResource | ISkillBlockResource>;
    };
}

export type IBadgeEarnedListQueryResult = IBadgeEarnedList;

const mapFilters = (filters: IBadgeEarnedListQueryParameters["filters"]) => {
    const { learner, skillGroup } = filters ?? {};

    return {
        "learner.uuid": mapRelationalFilter(learner),
        skillGroup: mapRelationalFilter(skillGroup),
    };
};

export const badgeEarnedListQuery: IApiQueryFunction<IBadgeEarnedListQueryParameters> = ({
    filters,
    pagination,
    order,
}) => {
    return {
        method: "GET",
        url: `/badge_earneds${serialize(
            {
                ...mapPagination(pagination),
                ...mapOrder(order),
                ...mapFilters(filters),
            },
            true,
        )}`,
    };
};

export const useBadgeEarnedListQuery = createApiQueryHook<IBadgeEarnedListQueryParameters, IBadgeEarnedListQueryResult>(
    badgeEarnedListQuery,
);
